import { render, staticRenderFns } from "./PublicPageShell.vue?vue&type=template&id=0920e616&scoped=true"
import script from "./PublicPageShell.vue?vue&type=script&lang=js"
export * from "./PublicPageShell.vue?vue&type=script&lang=js"
import style0 from "./PublicPageShell.vue?vue&type=style&index=0&id=0920e616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920e616",
  null
  
)

export default component.exports